export default function MySQL_CAST() {
  return (
    <div>
      <h2>MySQL_CAST</h2>    </div>
  );
}